import { Category } from '../types';
import { api } from '../api-client.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const updateCategory = (category: Category) =>
  api.put(`/categories/${category.id}`, category);

export const useUpdateCategoryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['update-category'],
    mutationFn: updateCategory,
    onSuccess: () => {
      toast.success('Category updated successfully');

      queryClient.invalidateQueries({
        queryKey: ['categories'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
